import { render, staticRenderFns } from "./BrandThemeSettings.vue?vue&type=template&id=4e5e5234&scoped=true&"
import script from "./BrandThemeSettings.vue?vue&type=script&lang=js&"
export * from "./BrandThemeSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrandThemeSettings.vue?vue&type=style&index=0&id=4e5e5234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e5234",
  null
  
)

export default component.exports